import StandardGateway from './lib/standard_gateway';

export default class FavoriteAnswersGateway extends StandardGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/agents/:agentId/favorite-answers/:answerId');
  }
}
